// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip .icon[data-v-86f24f78]{position:absolute;cursor:pointer;pointer-events:all;transform:translate(50%,-50%);top:0;right:0;width:20px;height:20px;color:#faaa00;color:var(--bps-button-tooltip,#faaa00);font-size:12px;border-radius:50%;display:inline-flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = exports;
